import { decodeDeepLink } from "@tg-gallery/deep-links"
import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router"
import { apiFetch } from "./lib/api.js"
import { getTelegramWebApp, isTelegramMiniApp } from "./lib/telegram.js"
import { GalleryPage } from "./pages/GalleryPage.js"
import { GallerySettingsPage } from "./pages/GallerySettingsPage.js"
import { HomePage } from "./pages/HomePage.js"
import { StoreProvider, useStore } from "./stores/StoreProvider.js"

function AppInner() {
  const { authStore, viewerStore } = useStore()

  useEffect(() => {
    const webapp = getTelegramWebApp()
    if (webapp) {
      webapp.ready()
      webapp.expand()
    }

    void authStore.authenticate()
  }, [authStore])

  // Handle deep links from Telegram startapp param
  useEffect(() => {
    if (!isTelegramMiniApp()) return
    const webapp = getTelegramWebApp()
    const startParam = webapp?.initDataUnsafe?.start_param
    if (!startParam) return

    const cmd = decodeDeepLink(startParam)
    if (!cmd) return

    switch (cmd.type) {
      case "open_gallery":
        window.location.hash = `/g/${cmd.slug}`
        break
      case "view_photo": {
        void apiFetch<{ gallerySlug: string }>(`/api/media/${cmd.mediaId}/context`).then((res) => {
          if (res.status === "ok") {
            viewerStore.pendingMediaId = cmd.mediaId
            window.location.hash = `/g/${res.data.gallerySlug}`
          }
        })
        break
      }
      case "purchase":
        // Navigate to gallery and trigger purchase flow
        break
    }
  }, [viewerStore])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/g/:slug" element={<GalleryPage />} />
        <Route path="/gallery/:id/settings" element={<GallerySettingsPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export function App() {
  return (
    <StoreProvider>
      <AppInner />
    </StoreProvider>
  )
}
